import { useEffect, useState } from 'react';

// Tracks whether the viewport is at or below `maxWidth` (default 960px), so a
// component can swap a desktop layout for a stacked/compact one. Uses matchMedia
// (cheap, fires only on breakpoint crossings) and is SSR-safe.
export default function useIsMobile(maxWidth = 960) {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    // addEventListener is the modern API; addListener is the Safari < 14 fallback.
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);
  return isMobile;
}
